import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { ForcePasswordChangeModal } from "../components/ForcePasswordChangeModal";

const AuthCtx = createContext({
  user: null, loading: true,
  login: async () => {}, register: async () => {},
  logout: async () => {}, setUser: () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("spicy_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("spicy_token");
        delete api.defaults.headers.common["Authorization"];
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const persistToken = (token) => {
    localStorage.setItem("spicy_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) persistToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, username) => {
    const { data } = await api.post("/auth/register", { email, password, username });
    if (data.token) persistToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("spicy_token");
    delete api.defaults.headers.common["Authorization"];
    setUser(null);
  };

  const changePassword = async (current_password, new_password) => {
    const { data } = await api.post("/auth/change-password", { current_password, new_password });
    if (data.token) persistToken(data.token);
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser, changePassword }}>
      {children}
      <ForcePasswordChangeModal />
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
